// Numbers as af_label.py prints them. The label, the screen preview and the QR record all use these,
// so a value never reads one way on the label and another on the QR page.

/** Python's f"{x:g}": 12.0 is "12", 1.25 is "1.25". */
export const g = (x: number): string => {
  if (x === 0) return "0";
  const s = Number(x.toPrecision(6)).toString();
  return /e/.test(s) ? x.toExponential(5).replace(/\.?0+e/, "e") : s;
};
/** Python's f"{x:.1f}". Both round the exact binary value, so they agree except on an exact half
 *  (14.25 is exact in binary): Python rounds to even ("14.2"), toFixed rounds up ("14.3"). 9.95 is not
 *  exact (9.9499...), so both give "9.9". The test for an exact half reads the full expansion. */
export const f1 = (x: number): string => {
  const exact = x.toFixed(30);
  const m = /^(-?)(\d+)\.(\d)50*$/.exec(exact);
  if (!m) return x.toFixed(1);
  const tenths = Number(m[2]) * 10 + Number(m[3]);
  const even = tenths % 2 === 0 ? tenths : tenths + 1;
  return `${m[1]}${Math.floor(even / 10)}.${even % 10}`;
};
